import { apiSlice } from "./apiSlice";

const TODOS_URL = "/api/product";

export const productApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // =========================
    // CART - GET
    // =========================
    getTodos: builder.query({
      query: () => ({
        url: `${TODOS_URL}/`,
      }),

      providesTags: ["Cart"],
    }),

    // =========================
    // CART - ADD
    // =========================
    addTodo: builder.mutation({
      query: (todo) => ({
        url: `${TODOS_URL}/`,
        method: "POST",
        body: todo,
      }),

      invalidatesTags: ["Cart"],
    }),

    // =========================
    // CONFIRM
    // =========================
    addConfirm: builder.mutation({
      query: (todo) => ({
        url: `${TODOS_URL}/confirm`,
        method: "POST",
        body: todo,
      }),
    }),

    // =========================
    // PAYMENT
    // =========================
    addPayment: builder.mutation({
      query: (body) => ({
        url: `${TODOS_URL}/payment`,
        method: "POST",
        body: body,
      }),
    }),

    // =========================
    // CART - UPDATE QUANTITY
    // =========================
    updateTodo: builder.mutation({
      query: ({ productId, quantity }) => ({
        url: `${TODOS_URL}/stock/${productId}`,
        method: "PUT",
        body: { quantity },
      }),

      invalidatesTags: ["Cart"],
    }),

    // =========================
    // CART - DELETE
    // =========================
    deleteTodo: builder.mutation({
      query: (id) => ({
        url: `${TODOS_URL}/${id}`,
        method: "DELETE",
      }),

      invalidatesTags: ["Cart"],
    }),
  }),
});

export const {
  useGetTodosQuery,
  useAddTodoMutation,
  useDeleteTodoMutation,
  useUpdateTodoMutation,
  useAddConfirmMutation,
  useAddPaymentMutation,
} = productApiSlice;